<template>
  <BlocksCard class="blocks-development-commute-time">
    <h2 class="__heading __underlined">
      Commute Time
    </h2>
    <ul class="__commute-time-list">
      <li v-for="(commuteTime, key) in commuteTimeDataResults" :key="`commute-time-${key}`">
        <div class="__destination">
          <nuxt-link :to="`https://www.google.com/maps/place/${commuteTime.destinationAddress.formattedAddress}`" target="_blank">
            {{ commuteTime.destinationName }}
          </nuxt-link>
        </div>
        <div class="__time-and-distance">
          <div v-for="(commuteTimeBy, timeByKey) in commuteTime.commuteTimeData" :key="`commute-time-by-${timeByKey}`" class="__time-and-distance-by">
            <img v-lazy-load  class="__time-and-distance-image" :data-src="getImage(timeByKey)">
            {{ commuteTimeBy.duration.text }}
            <span class="__distance">/ {{ commuteTimeBy.distance.text }}</span>
          </div>
        </div>
      </li>
    </ul>
  </BlocksCard>
</template>

<script setup lang="ts">
import driving from '~/assets/images/icons/car-30.webp';
import walking from '~/assets/images/icons/walking-30.webp';
import cycling from '~/assets/images/icons/cycling-30.webp';
import {CommuteTimeDataResult} from '~/@types/development';

const props = defineProps({
  commuteTimeDataResults: {
    type: Array as PropType<CommuteTimeDataResult[]>,
    default: () => [],
  },
});

function getImage (method: 'DRIVING' | 'WALKING' | 'BICYCLING') {
  switch (method) {
    case 'DRIVING':
      return driving;
    case 'BICYCLING':
      return cycling;
    case 'WALKING':
      return walking;
  }
}
</script>

<style lang="scss">
.blocks-development-commute-time {
  .__commute-time-list {
    li {
      padding-bottom: 25px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      a {
        text-decoration: none;
        color: rgb(var(--text-default));
        transition: color 0.2s ease;

        &:hover {
          color: rgb(var(--accent));
          transition: color 0.2s ease;
        }
      }

      .__icon-wrapper {
        img {
          width: 25px;
          height: auto;
        }
      }

      .__time-and-distance {
        font-weight: 500;
        display: flex;
        flex-direction: column;
        min-width: 55%;
        padding-left: 12px;

        .__time-and-distance-by {
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 5px 12px;
          padding: 4px 8px;
          background: rgba(92, 82, 198, 0.1);
          border-radius: 10px;
        }

        .__time-and-distance-image {
          width: 18px;
          height: auto;
          margin-right: 5px;
        }

        .__distance {
          margin-top: 5px;
          color: rgba(var(--text-default), 0.4);
        }
      }
    }
  }
}
</style>
